module.exports = __webpack_public_path__ + "img/qixiaohang.0d6b1a12.png";